import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../auth/AuthContext";
import { claimPendingInvite } from "../../api/trips";
import { Hero } from "./Hero";
import { LandingPageForm } from "../../components/common/LandingPageForm";
import { TripsSection } from "./TripsSection";
import { ThreeStepGuide } from "../../components/common/ThreeStepGuide";
import { ExamplesSection } from "./ExamplesSection";
import "./HomePage.less";

export function HomePage() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const formRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!user) return;
    claimPendingInvite()
      .then((result) => {
        if (result.tripId) navigate(`/trips/${result.tripId}`);
      })
      .catch(() => {});
  }, [navigate, user]);

  const scrollToForm = () => {
    formRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="home-page">
      <main>
        <Hero />
        <div className="lp-form-anchor" ref={formRef}>
          <LandingPageForm />
        </div>
        <TripsSection onScrollToForm={scrollToForm} />
        <ExamplesSection />
        <ThreeStepGuide />
      </main>
    </div>
  );
}
